module.exports = __webpack_public_path__ + "static/media/phone-05.160c3481.png";